// test2007
(2007 && 0);
